import { FETCH_INSTITUION_ATTRIBUTES } from 'stores/redux/actions/types';
import hOReducer from '../common/reducer';

const reducer = hOReducer(FETCH_INSTITUION_ATTRIBUTES);
export default reducer;
